<template>
  <div class="row">
    <div class="col-12">
      <ibox
        :title="this.$t('nav.training-dates-list')"
        :collapseId="'collapse-2'"
      >
        <template slot="content" slot-scope="{ setLoading }">
          <TrainingStylistsForm @loading="setLoading" />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from "@/components/base/Ibox.vue";
import TrainingStylistsForm from "@/components/Courses/TrainingStylistsForm.vue";

export default {
  name: "TrainingStylistsDetails",
  components: {
    Ibox,
    TrainingStylistsForm
  },
  data() {
    return {
      excel: true
    };
  }
};
</script>
